import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router";
import { binanceAPI } from "../api/binanceAPI";
import { coingeckoAPI } from "../api/coingeckoAPI";
import queryString from "query-string";

const numberWithCommas = (x: number) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const SLPPHPConverterFC: React.FC = () => {
  const [ETHUSDT, setETHUSDT] = useState<number>();
  const [SLPETH, setSLPETH] = useState<number>();
  const location = useLocation();
  const { count } = queryString.parse(location.search);
  const [slpCount, setSlpCount] = useState<number>(
    (count && Number.isInteger(Number(count)) && Number(count)) || 1
  );
  const history = useHistory();
  const USDTPHP = 47;

  const [SLPInfo, setSLPInfo] = useState<any>();

  useEffect(() => {
    coingeckoAPI
      .get(
        "/coins/ethereum/contract/0x37236cd05b34cc79d3715af2383e96dd7443dcf1"
      )
      .then((res) => setSLPInfo(res.data));
  }, []);

  useEffect(() => {
    const getPrices = () => {
      binanceAPI
        .get("/avgPrice", {
          params: {
            symbol: "ETHUSDT",
          },
        })
        .then((response) => {
          setETHUSDT(Number(response.data.price));
        });
      binanceAPI
        .get("/avgPrice", {
          params: {
            symbol: "SLPETH",
          },
        })
        .then((response) => {
          setSLPETH(Number(response.data.price));
        });
    };
    const updaterID = window.setInterval(getPrices, 3000);
    return () => {
      if (updaterID) window.clearInterval(updaterID);
    };
  }, []);

  const totalCashout = useMemo(() => {
    if (SLPETH && ETHUSDT) {
      const eth = slpCount * SLPETH * 0.999;
      const usdt = eth * ETHUSDT * 0.999;
      const php = usdt * USDTPHP;
      return php;
    }
    return 0;
  }, [slpCount, SLPETH, ETHUSDT]);

  return (
    <div
      style={{
        textAlign: "center",
        border: "1px solid black",
        padding: 20,
      }}
    >
      <img src={SLPInfo?.image?.small} />
      <h1>Sell SLP To PHP</h1>
      <div>
        <input
          type="number"
          value={slpCount}
          onChange={(e) => setSlpCount(Number(e.target.value))}
          onBlur={(e) =>
            history.replace({
              pathname: history.location.pathname,
              search: `?count=${slpCount}`,
            })
          }
          title="SLP Pieces"
          placeholder="Input amount of SLP"
        />
      </div>
      <div>
        {SLPETH ? (
          <p>current slp/eth rate: {SLPETH.toFixed(8)}</p>
        ) : (
          "loading..."
        )}
      </div>
      <div>
        {ETHUSDT ? (
          <p>current eth/usdt rate: {ETHUSDT.toFixed(2)}</p>
        ) : (
          "loading..."
        )}
      </div>
      <div>
        <p>Total Rate: {(totalCashout / slpCount).toFixed(2)}</p>
      </div>
      <div
        style={{
          border: "1px solid red",
          width: "max-content",
          textAlign: "center",
          margin: "0 auto",
        }}
      >
        Total Cashout: {numberWithCommas(Number(totalCashout.toFixed(2)))} PHP
      </div>
      <p>Please note that these are indicative rates.</p>
      <p>
        Message us on facebook&nbsp;
        <a href="https://www.facebook.com/AbraEXCH" target="_blank">
          @AbraEX
        </a>
      </p>
    </div>
  );
};

const SLPPHPConverter = React.memo(SLPPHPConverterFC);

export default SLPPHPConverter;
